var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"options":this.languages,"clear-search-on-select":false,"searchable":false,"clearable":false,"append-to-body":"","calculate-position":_vm.withPopper,"label":"title"},scopedSlots:_vm._u([{key:"option",fn:function(ref){
var code = ref.code;
var title = ref.title;
var img = ref.img;
return [_c('span',{staticClass:"select-option"},[_c('img',{attrs:{"src":img,"height":"30"}}),_vm._v(" "+_vm._s(title)+" ")])]}},{key:"selected-option",fn:function(ref){
var code = ref.code;
var title = ref.title;
var img = ref.img;
return [_c('span',{staticClass:"select-option"},[_c('img',{attrs:{"src":img,"height":"30"}}),_vm._v(" "+_vm._s(title)+" ")])]}}]),model:{value:(_vm.selectedLanguage),callback:function ($$v) {_vm.selectedLanguage=$$v},expression:"selectedLanguage"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }